import { SellingPlan } from '../../models/selling-plan'

type intervalType = 'day' | 'week' | 'month' | 'year'

export const sortingByFrequency = (plan1: SellingPlan, plan2: SellingPlan) => {
  const plan1Count = getCountInDays(plan1)
  const plan2Count = getCountInDays(plan2)
  return plan1Count - plan2Count
}

const getCountInDays = (plan: SellingPlan) => {
  if (!plan.name) {
    return 0
  }
  const parts = plan.name.split(' ')
  const has2PartsAtLeast = parts.length >= 2
  if (!has2PartsAtLeast) {
    return 0
  }
  const startsWithEvery = parts[0].toLowerCase() === 'every'
  if (!startsWithEvery) {
    return 0
  }
  const count = parts.length === 2 ? '1' : parts[1]
  const type = parts.length === 2 ? parts[1] : parts[2]
  return getIntervalDays(count, type)
}

const getIntervalDays = (countStr: string, typeStr: string): number => {
  const intervalCount = parseInt(countStr, 10)
  if (!intervalCount) {
    return 0
  }
  const intervalType = getIntervalType(typeStr)
  if (!intervalType) {
    return 0
  }
  return getIntervalCountInDays(intervalType, intervalCount)
}

const getIntervalCountInDays = (type: intervalType, intervalCount: number): number => {
  switch (type) {
    case 'day':
      return intervalCount
    case 'week':
      return 7 * intervalCount
    case 'month':
      return 30 * intervalCount
    case 'year':
      return 365 * intervalCount
  }
}

const getIntervalType = (namePart: string): intervalType | '' => {
  switch (namePart.toLowerCase()) {
    case 'day':
    case 'days':
      return 'day'
    case 'week':
    case 'weeks':
      return 'week'
    case 'month':
    case 'months':
      return 'month'
    case 'year':
    case 'years':
      return 'year'
  }
  return ''
}
